import React, { Fragment } from 'react'
import {
  shape, string, bool, func,
} from 'prop-types'

import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'
import Icon from 'Pods/Shared/Icon/Icon'

function UserInfoSectionHeader({ userInfo = {
  fullName: '',
  occupation: '',
  location: '',
  avatar: '',
}, handleLocationClick }) {
  return (
    <Fragment>
      <a href={`/designers/${userInfo.username}`}>
        <div className="user-data__avatar-wrapper">
          <UserAvatar
            userName={userInfo.username}
            size="huge"
            img={userInfo.avatar}
          />
        </div>
      </a>
      <h2 className="heading-20 text-bold">
        <a href={`/designers/${userInfo.username}`} className="link--primary">{userInfo.fullName || userInfo.username}</a>
      </h2>
      {userInfo.occupation && <p className="text-extra-small user-data__occupation">{userInfo.occupation}</p>}
      {userInfo.location && (
        <p className="user-data__location user-data__location--short text-extra-small">
          <span
            onClick={() => { handleLocationClick(userInfo.location) }}
          >
            <Icon type={['far', 'map-marker-alt']} />
            <span>
              {userInfo.location}
            </span>
          </span>
        </p>
      )}
    </Fragment>
  )
}

UserInfoSectionHeader.propTypes = {
  userInfo: shape({
    username: string.isRequired,
    fullName: string,
    occupation: string,
    location: string,
    avatar: string,
  }),
  handleLocationClick: func.isRequired,
}

export default UserInfoSectionHeader
